import theme from "../../theme";

// Shared muted tones for the engagement screens. Kept module-local so the global
// palette stays minimal — the theme has Violet/DodgerBlue/Porcelain/Gallery but
// no neutral grays of its own.
export const tokens = {
  primary: theme.colors.DodgerBlue,
  text: theme.colors.Violet,
  textMuted: "#64748B",
  textSubtle: "#94A3B8",
  surface: theme.colors.White,
  surfaceAlt: theme.colors.Porcelain,
  border: theme.colors.Gallery,
  borderSoft: theme.colors.Porcelain,
  tint: theme.colors.Zumthor,
};

// Status palette for campaigns — sourced from theme where the meaning maps cleanly.
export const STATUS_STYLE = {
  DRAFT:     { bg: theme.colors.Porcelain, color: tokens.textMuted },
  SCHEDULED: { bg: theme.colors.Zumthor,   color: theme.colors.DodgerBlue },
  RUNNING:   { bg: "#DCFCE7",              color: theme.colors.ApproveGreen },
  COMPLETED: { bg: "#DCFCE7",              color: theme.colors.ApproveGreenDark },
  PAUSED:    { bg: "#FEF3C7",              color: "#B7791F" },
  CANCELLED: { bg: theme.colors.Cinderella, color: theme.colors.RejectRed },
};

// Channel palette for templates. Push/All map to brand colors; the rest stay
// distinct but recognizable.
export const CHANNEL_COLORS = {
  PUSH:           theme.colors.DodgerBlue,
  SMS:            "#F59E0B",
  EMAIL:          theme.colors.ApproveGreen,
  PUSH_AND_SMS:   "#8B5CF6",
  PUSH_AND_EMAIL: "#06B6D4",
  SMS_AND_EMAIL:  "#F97316",
  ALL:            theme.colors.Violet,
};

// Mirrors bonusesAdmin/utils.js — normalize a reducer error (string | string[] | object)
// into an array suitable for enqueueing as notistack toasts.
export const toMessages = (error, fallback = "Something went wrong.") => {
  if (!error) return [fallback];
  if (Array.isArray(error)) {
    const filtered = error.filter(Boolean);
    return filtered.length ? filtered : [fallback];
  }
  if (typeof error === "string") return [error];
  if (typeof error?.message === "string") return [error.message];
  return [fallback];
};

// Maps reducer.lastMutation → success toast text. Kept here so each component
// doesn't carry its own switch.
export const SUCCESS_MESSAGES = {
  segment_create:  "Segment created.",
  campaign_create: "Campaign created.",
  campaign_launch: "Campaign launched.",
  campaign_pause:  "Campaign paused.",
  campaign_cancel: "Campaign cancelled.",
};

export const ERROR_FALLBACKS = {
  segment_create:    "Failed to create segment.",
  segment_list:      "Unable to load segments.",
  segment_preview:   "Unable to preview segment.",
  template_list:     "Unable to load templates.",
  campaign_create:   "Failed to create campaign.",
  campaign_launch:   "Failed to launch campaign.",
  campaign_pause:    "Failed to pause campaign.",
  campaign_cancel:   "Failed to cancel campaign.",
  campaign_analytics: "Unable to load analytics.",
};
